/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
import { FloatButton } from 'antd'

import { Chatbot } from './Chatbot'
import { ChatbotFloatButton } from './components/ChatbotFloatButton'
import { ChatbotInputCard } from './components/ChatbotInputCard'
import { ChatbotSidePanel } from './components/ChatbotSidePanel'
import { Conversation } from './components/Conversation'
import { FloatWindow } from './components/FloatWindow'
import {
  ChatbotAttachmentContext,
  ChatbotAttachmentProvider,
  useChatbotAttachments,
  useChatbotAttachmentsOptional,
} from './contexts/ChatbotAttachmentContext'
export {
  Chatbot,
  ChatbotAttachmentContext,
  ChatbotAttachmentProvider,
  ChatbotFloatButton,
  ChatbotInputCard,
  ChatbotSidePanel,
  Conversation,
  FloatButton,
  FloatWindow,
  useChatbotAttachments,
  useChatbotAttachmentsOptional,
}
